import React, { FC } from "react";
import produce from "immer";
import { startEditElement } from "../../../../actions/elementListAction";
import { useDispatch } from "react-redux";
import { Element } from "../../../../models/elementModel";
import { Accordion } from "react-bootstrap";
import ActionProperties from "./actionProperties";

export interface RulePropertiesProps {
    element: Element;
}

const RuleProperties:FC<RulePropertiesProps> = ({element}) =>{
    const dispatch = useDispatch();

    return(
    <div className="container mt-3">
        {/* <div className="card">
            <div className="card-header" id="RuleProperties">
                <h5 className="mb-0">
                    <button className="btn btn-link collapsed" data-toggle="collapse" data-target="#rule-element-prop" aria-expanded="false" aria-controls="rule-element-prop">Rule</button>
                </h5>
            </div>
            <div id="rule-element-prop" className="collapse" aria-labelledby="RuleProperties">
                <div className="card-body"> */}
                    <Accordion>
                        <ActionProperties element={element}/>
                    </Accordion>
                {/* </div>
            </div>
        </div> */}
    </div>
    );
}

export default RuleProperties;